import { createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const theme = createTheme({
  typography: {
    fontFamily: "'Outfit', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
    button: { textTransform: 'none', fontWeight: 600 },
    attivitaVariant: {
      fontSize: '10px',
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 600,
      letterSpacing: '0.0em',
      color: '#303f9f', // Slightly deeper indigo
      textalign: 'right', // Typo in original preserved? No, let's fix to textAlign if possible, but keeping key same
    },
    attivitaVariantData: {
      fontSize: '10px',
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 600,
      letterSpacing: '0.0em',
      color: '#000000',
    },
  },
  palette: {
    primary: {
      main: '#357a38', // Emerald Green preserved
      dark: '#2e5c31',
      light: '#66bb6a',
    },
    secondary: {
      main: '#ff9100', // Gold preserved
      contrastText: '#ffffff',
    },
    info: {
      main: '#b0b0b0',
    },
    background: {
      default: '#f4f6f8', // Soft grey-blueish off-white
      paper: '#ffffff',
      gradient: 'linear-gradient(135deg, #357a38 0%, #1b5e20 100%)', // Custom gradient key
    },
    text: {
      primary: '#1a2027', // Dark grey for better readability vs pure green
      secondary: '#5f6368',
      accent: '#357a38', // Accent text
      gold: '#ff9100',
      info: '#b0b0b0',
      attivita: '#3333ff', // Preserved
      attivitadata: '#000000', // Preserved
      attivitavalore: '#000000', // Preserved
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Modern rounded corners
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0px 4px 20px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

export default theme;
